import angular from 'angular';
import inventoryModule from '../inventoryModule';

function inventoryService($q, $filter, inventoryConstants, assetsService, httpService) {
  'ngInject';

  return {
    getInventoryItems(pagingParameters) {
      return $q(function (resolve, reject) {
        const urlConfig = {
          url: inventoryConstants.urls.getUserInventory
        };

        httpService
          .httpGet(urlConfig, {
            userId: pagingParameters.userId,
            itemsPerPage: pagingParameters.count,
            cursor: pagingParameters.cursor,
            assetTypeId: pagingParameters.assetTypeId,
            placeTab: pagingParameters.placeTab,
            pageNumber: pagingParameters.pageNumber // This is a hack because not everything on the inventory list-json endpoint uses cursor based paging. Ew.
          })
          .then(function (response) {
            const items = response.Data ? response.Data.Items : [];
            angular.forEach(items, assetsService.translateWwwItem);

            resolve({
              nextPageCursor: response.Data && response.Data.nextPageCursor,
              items
            });
          })
          .catch(function (response) {
            reject(response.Data || response.error || '');
          });
      });
    },

    getBundles(pagingParameters) {
      return $q(function (resolve, reject) {
        const urlConfig = {
          url: $filter('formatString')(inventoryConstants.urls.getBundles, {
            userId: pagingParameters.userId
          })
        };

        httpService
          .httpGet(urlConfig, {
            limit: pagingParameters.count,
            nextPageCursor: pagingParameters.cursor,
            sortOrder: pagingParameters.sortOrder
          })
          .then(function (response) {
            const items = response.data ? response.data : [];
            angular.forEach(items, assetsService.translateCatalogItem);

            resolve({
              nextPageCursor: response.nextPageCursor,
              items
            });
          })
          .catch(function (response) {
            reject(response.error || '');
          });
      });
    },

    getCategories(userId) {
      const urlConfig = {
        url: $filter('formatString')(inventoryConstants.urls.getCategories, {
          userId
        })
      };

      const params = {};

      const result = httpService.httpGet(urlConfig, params);

      return result;
    }
  };
}

inventoryModule.factory('inventoryService', inventoryService);
export default inventoryService;
